import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {}
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance;
function Key_getInstance() {
  return Key_instance;
}
var TelemetryContextClass;
function TelemetryContext() {
  if (TelemetryContextClass === VOID) {
    class $ {
      constructor(traceId, spanId, element, sampled) {
        traceId = traceId === VOID ? '' : traceId;
        spanId = spanId === VOID ? '' : spanId;
        element = element === VOID ? null : element;
        sampled = sampled === VOID ? false : sampled;
        this.traceId_1 = traceId;
        this.spanId_1 = spanId;
        this.element_1 = element;
        this.sampled_1 = sampled;
      }
      get_key_18j28a_k$() {
        return Key_instance;
      }
    }
    protoOf($).get_y2st91_k$ = get;
    protoOf($).fold_j2vaxd_k$ = fold;
    protoOf($).minusKey_9i5ggf_k$ = minusKey;
    protoOf($).plus_s13ygv_k$ = plus;
    initMetadataForClass($, 'TelemetryContext', TelemetryContext, VOID, [Element()]);
    TelemetryContextClass = $;
  }
  return TelemetryContextClass;
}
//region block: init
Key_instance = new (Key())();
//endregion
//region block: exports
export {
  TelemetryContext as TelemetryContext3p4gcznz77gxw,
};
//endregion

//# sourceMappingURL=TelemetryContext.mjs.map
